import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
@Injectable({
  providedIn: 'root'
})
export class CardPaymentService {
  public isLoggedIn: boolean = false;
  public server = environment.APIEndpoint;
  public authType = 'Bearer';
  public urls: any = {
    getAllCards: this.server + 'api/unsec/cms/giftCard/v2/get',
    getAllUnsecGiftCards: this.server + 'unsec/giftCard/getAllEGiftCards/v1',
    getAllDigitalGiftCards: this.server + 'portal/giftCard/getAllDigitalGiftCards/v1',
    createPhysicalCard: this.server + 'api/msrcard/v3/add/physical/card',
    initiateGiftCard: this.server + 'api/user/msrcard/egift/v3/initiate',
    guestInitiateGiftCard: this.server + 'api/unsec/user/msrcard/egift/v3/initiate',
    initiateDigitalCard: this.server + 'api/user/msrcard/digital/v3/initiate',
    commitCard: this.server + 'api/payment/msr/v3/commit',
    commitForGuestUser: this.server + 'api/unsec/payment/msr/v3/commit',
    listMsrCard: this.server + 'user/list/msrCards/v1',
    saveCardSettings: this.server + 'api/user/msrcard/settings',
    removeCard: this.server + 'api/user/msrcard/settings/managecard',
    deleteMSRCard: this.server + 'api/user/msrcard/v3/remove',
    manualReload: this.server + 'api/user/msrcard/reload/v3/initiate',
    transferBalance: this.server + 'api/user/msrcard/balance/v1/transfer',
    pastTransactions: this.server + 'api/user/get/pastTransactions/v1',
    getSecGiftCardDynamicLink: this.server + 'api/user/msrcard/v1/dynamicLink',
    getUnsecGiftCardDynamicLink: this.server + 'api/unsec/user/msrcard/v1/dynamicLink',
    getGifteeDetailsByKey: this.server + 'api/user/msrcard/giftee/v1/details'
  }
  public deviceMetaInfo = {
    "appVersion": "",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId"),
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  };
  constructor(private http: HttpClient, private commonFunction: CommonFunctions, private apiHeader: ApiHeaderService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  //Physical card
  addPhysicalCard(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.createPhysicalCard, requestData, { headers: secureHeaders });
  }
  //Digital card
  getAllDigitalGiftCards() {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.getAllDigitalGiftCards, { headers: secureHeaders });
  }
  initiateDigitalCard(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.initiateDigitalCard, requestData, { headers: secureHeaders });
  }
  commitCard(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    let unsecureHeaders = this.apiHeader.getUnSecureHeader();
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    return this.http.post(isLoggedIn ? this.urls.commitCard : this.urls.commitForGuestUser, requestData, { headers: isLoggedIn ? secureHeaders : unsecureHeaders });
  }
  //Gift card
  getAllCards(requestParam) {
    let headers = {
      'Accept-Language': 'EN',
      'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
      'cardType': requestParam
    }
    return this.http.get(this.urls.getAllCards, { headers: headers });
  }
  initiateGiftCard(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    let unsecureHeaders = this.apiHeader.getUnSecureHeader();
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    return this.http.post(isLoggedIn ? this.urls.initiateGiftCard : this.urls.guestInitiateGiftCard, requestData, { headers: isLoggedIn ? secureHeaders : unsecureHeaders });
  }
  //Payment module
  listMsrCards() {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secureHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.listMsrCard, { headers: secureHeaders });
    }
  }
  saveCardSettings(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.saveCardSettings, requestData, { headers: secureHeaders });
  }
  removeCard(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.removeCard, requestData, { headers: secureHeaders });
  }
  manualReload(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.manualReload, requestData, { headers: secureHeaders });
  }
  transferBalance(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.transferBalance, requestData, { headers: secureHeaders });
  }
  getPastTransactions(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.pastTransactions, requestData, { headers: secureHeaders });
  }
  getGiftCardDynamicLink(queryParam) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    let unsecureHeaders = this.apiHeader.getUnSecureHeader();
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    return this.http.get(isLoggedIn ? this.urls.getSecGiftCardDynamicLink + '?orderId=' + queryParam : this.urls.getUnsecGiftCardDynamicLink + '?orderId=' + queryParam, { headers: isLoggedIn ? secureHeaders : unsecureHeaders });
  }
  deleteMSRCard(requestData) {
    let secureHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.deleteMSRCard, requestData, { headers: secureHeaders });
  }
  getGifteeDetails(gifteeKey) {
      let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secureHeaders = this.apiHeader.getSecureHeader();
      secureHeaders['gifteeKey'] = gifteeKey;
      return this.http.get(this.urls.getGifteeDetailsByKey, { headers: secureHeaders });
    }
  }
}
